const cardList = document.querySelectorAll('.card-list');

const updateTextHeight = (element) => {
  const activeItems = element.querySelectorAll('[data-height].is-active');
  activeItems.forEach((el) => {
    const parent = el.closest('[data-height-parent]');
    const height = el.offsetHeight;
    parent.style.setProperty('--text-height', `${height}px`);
  });
};

const debouncedUpdateTextHeight = debounce(updateTextHeight, 200);

cardList.forEach((element) => {
  window.addEventListener('resize', () => debouncedUpdateTextHeight(element));
  updateTextHeight(element);
});

const axiosGetFilteredProducts = async (action, variation, initialData, slug, list, errorElem) => {
  const nonce = await getNonceForAction(action);

  const data = {
    action,
    variation,
    initialData,
    slug,
    nonce,
  };

  try {
    const response = await axios.post(localData.siteURL, data);
    list.innerHTML = '';
    list.innerHTML = response.data.data.html;
    if (!response.data.data.html) {
      errorElem.classList.remove('hide');
    }
  } catch (err) {
    console.error(err);
  }
};

attachEvent('.card-list .mod-tag', 'click', ({ target }) => {
  const dataSlug = target.getAttribute('data-slug');
  const parent = target.closest('.card-list');
  const list = parent.querySelector('.card-list__items');
  const noResultElem = parent.querySelector('.card-list__no-result');

  // Toggle active class on buttons
  const preselectedBtn = parent.querySelector('.mod-tag.is-active');
  toggleActiveClass(preselectedBtn, false);
  toggleActiveClass(target, true);

  // Toggle active class on titles
  const preselectedTitle = parent.querySelector('.card-list__title-item.is-active');
  const targetTitle = parent.querySelector(`[data-title="${dataSlug}"]`);
  toggleActiveClass(preselectedTitle, false);
  toggleActiveClass(targetTitle, true);

  // Toggle active class on text elements
  const preselectedText = parent.querySelector('.card-list__text-inner.is-active');
  const targetText = parent.querySelector(`[data-text="${dataSlug}"]`);
  toggleActiveClass(preselectedText, false);
  toggleActiveClass(targetText, true);

  // Update the height of the text container
  updateTextHeight(parent);

  // Filter AJAX Call
  const action = parent.querySelector('[data-action]').value;
  const variation = parent.querySelector('[data-variation]').value;
  const initialData = parent.querySelector('[data-initial]').value;
  axiosGetFilteredProducts(action, variation, initialData, dataSlug, list, noResultElem);
});
